import { SupportedLanguages } from '@/utils/locale';
import { SchemaItem } from '@/components/form/types/schemaItem';

export interface PostBody {
  [key: string]: unknown;
}

export interface Links {
  [key: string]: Link;
}

export interface Actions {
  [key: string]: Action;
}

export interface Link {
  uri: string;
  count?: number;
}

export enum Method {
  get = 'get',
  post = 'post',
  patch = 'patch',
  put = 'put',
  delete = 'delete'
}

export interface Action {
  uri: string;
  method: Method;
}

export interface Schema {
  additionalProperties?: boolean;
  properties: {
    [key: string]: SchemaItem | Schema | any;
  };
  required?: Array<string>;
  type: string;
  // below are fields present for GET schemas
  description?: string;
  in?: string;
  name?: string;
  schema?: SchemaItem;
  'x-ref'?: string;
}

export interface Address {
  street: string;
  /**
   * TODO: generated apis use `number`instead of `houseNo` migrate once all APIs are fully migrated.
   */
  houseNo: string;
  zip: string;
  town: string;
  poBox?: string;
  country: string;
  countryName?: string;
}
export interface AddressV2 {
  city?: string;
  country?: string;
  number?: string;
  postBoxAddrs?: string;
  postalCode?: string;
  province?: string;
  state?: string;
  street?: string;
  countryName?: string;
}

export interface UnstructuredAddress {
  addressLines: Array<string>;
  country: string;
  countryName: string;
}

export type WithRequired<T, K extends keyof T> = T & { [P in K]-?: T[P] };

export type RequireOne<T, Keys extends keyof T> = {
  [K in Keys]: Required<Pick<T, K>> & Partial<Omit<T, K>>;
}[Keys];

export type Partial<T> = {
  [P in keyof T]?: T[P];
};

export enum Theme {
  DARK_THEME = 'dark',
  LIGHT_THEME = 'light'
}

export interface SubmissionError {
  [key: string]: {
    status: number;
    body: {
      code: number;
      httpStatusCode: number;
      errors?: any;
      message: string;
      details: Array<string>;
    };
  };
}

export type LocalizedString = {
  [key in SupportedLanguages]: string;
};

export enum MimeTypes {
  AllImages = 'image/*',
  CSV = 'text/csv',
  JPEG = 'image/jpeg',
  PNG = 'image/png',
  PDF = 'application/pdf',
  ImagesPDF = 'image/*,application/pdf'
}

export interface ErrorResponse {
  response?: {
    data?: ErrorMsg;
  };
}

interface ErrorMsg {
  httpStatusCode: number;
  code: number;
  message?: string;
  details?: string[];
  errors?: string[];
  entity?: string[];
}

export interface YapAmount {
  value: number;
  factor: number;
}

export interface YapMoney {
  amount: YapAmount;
  currency: string;
}

export interface ExternalAgentIdentifier {
  scheme: string;
  country: string;
  value: string;
}
